<template>
  <div class="header">
    <a class="logo fl" @click="handleEvent" v-if="android" :href="this.$config.androidAPPUrl"><img alt="LMK" src="/public/logo_v2.png" /></a>
    <a class="logo fl" @click="handleEvent" v-else :href="this.$config.iOSAPPUrl"><img alt="LMK" src="/public/logo_v2.png" /></a>
    <p class="name">LMK - Anonymous Messages</p>
    <p class="meta"><img src="/public/stars.png" />2.2k reviews</p>
    <a @click="handleEvent" v-if="ios" :href="this.$config.iOSAPPUrl" class="btn-open">GET</a>
    <a @click="handleEvent" v-else-if="android" :href="this.$config.androidAPPUrl" class="btn-open">GET</a>
  </div>
</template>
<script>
export default {
  data () {
    return {
      'ios': (this.$store.state.device == 'ios' || this.$store.state.device == 'desktop'),
      'android': (this.$store.state.device == 'android' || this.$store.state.device == 'desktop'),
      'desktop': (this.$store.state.device == 'desktop') ? true : false,

    }
  },
  methods: {
    handleEvent: function(event) {
      this.$ga.event('download', 'get_app', 'get_app')
    }
  }
}
</script>

<style lang="stylus">
.header
  height: 70px;
  background-color: #FFFFFF;
  width: 100%;
  border-bottom: 1px solid #ddd;
  position: fixed;
  top: 0;
  z-index: 200;

  .name
    position: absolute;
    top: 18px;
    left: 74px;
    font-size: 14px;

  .meta
    position: absolute;
    top: 40px;
    left: 74px;
    color: rgba(0,0,0,0.55);
    font-size: 13px;
    padding: 0 0 0 70px;

  .meta img
    position: absolute;
    top: 2px;
    left: 0;
    height: 12px

  .logo
    height: 50px;
    width: 50px;
    border-radius: 10px;
    position: absolute;
    top: 8px;
    left: 12px;
    img
      width 50px
      height 50px
      border-radius: 8px;

  .btn-open
    height: 30px;
    width: 72px;
    color: #fff;
    line-height: 30px;
    border-radius: 14px;
    text-align: center;
    font-size: 16px;
    position: absolute;
    right: 12px;
    top: 50%;
    margin-top: -15px;
    background-color: #17ACFE;
</style>



// WEBPACK FOOTER //
// HeaderAppstore.vue